/*************************************************************************
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export function areServiceWorkersSupported() {
  return "serviceWorker" in window.navigator;
}

export function registerServiceWorker(path, scope) {
  return window.navigator.serviceWorker.register(path, { scope });
}

export function addServiceWorkerEventListener(event, callback) {
  switch (event) {
    case "onmessage":
      window.navigator.serviceWorker.onmessage = callback;
      break;
    default:
  }
}
